import { NgModule } from "@angular/core";
import { ChildsComponent } from "./childs.component";
import { ComponentModule } from "../../../components/component.module";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { childsroutingmodule } from "./childs-routing.module";
import { GuardianinfoService } from "../../forms/school-management/Admission/guardianinfo/guardianinfo.service";
import { SMStudentinfoService } from "../../forms/school-management/transaction/studentprofile/studentprofile.service";
import { ImageService } from "../../shared/image.service";
import { SMBlockactivityService } from "../../forms/school-management/transaction/blockactivity/blockactivity.service";



@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ComponentModule,
    childsroutingmodule
  ],
  declarations: [ChildsComponent],
  providers: [
    GuardianinfoService,
    SMStudentinfoService,
    ImageService,
    SMBlockactivityService
  ]
})
export class childsModule {}



// WEBPACK FOOTER //
// ./src/app/shell/Parent-Portal/childs/childs.module.ts